import { render, staticRenderFns } from "./TransferNft.vue?vue&type=template&id=27b7e126&"
import script from "./TransferNft.vue?vue&type=script&lang=js&"
export * from "./TransferNft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports